import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";

const Kbd = ({ className, ...props }: ComponentProps<"kbd">) => {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        `
          pointer-events-none inline-flex h-5 w-fit min-w-5 items-center
          justify-center gap-1 rounded-sm bg-black/5 px-1 font-sans text-xs
          font-medium text-foreground/45 select-none
        `,
        "[&_svg:not([class*='size-'])]:size-3",
        `
          in-data-[slot=tooltip-content]:bg-current/15
          in-data-[slot=tooltip-content]:text-inherit
        `,
        className,
      )}
      {...props}
    />
  );
};

const KbdGroup = ({ className, ...props }: ComponentProps<"div">) => {
  return (
    <div
      data-slot="kbd-group"
      className={cn("inline-flex items-center gap-1", className)}
      {...props}
    />
  );
};

export { Kbd, KbdGroup };
